import { render } from "./NewPost.vue?vue&type=template&id=14ad4c96&ts=true"
import script from "./NewPost.vue?vue&type=script&lang=ts"
export * from "./NewPost.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__